import { oz } from '@weft/utils';

export const PercentagePromotionConfigurationInputSchema = oz.object({
  percentage: oz.number().nonnegative().max(100).min(1).nullable(),
  recurringAmount: oz.number({ invalid_type_error: 'Recurring discount is required' }).step(1).optional(),
}).openapi('PercentagePromotionConfigurationInput');

export type PercentagePromotionConfigurationInput = oz.infer<typeof PercentagePromotionConfigurationInputSchema>;